import type { DriverDeviceEventView, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import type { useListQuery } from '../../../shared/hooks/use-list-query';
import { DEVICE_EVENT_LABELS, describeEventDevice } from '../policies/device-event-labels';

type ListControls = Pick<ReturnType<typeof useListQuery>, 'tableProps'>;

const COLUMNS: TableColumnsType<DriverDeviceEventView> = [
  { title: 'When', key: 'occurredAt', render: (_, event) => new Date(event.occurredAt).toLocaleString() },
  {
    title: 'What',
    key: 'kind',
    render: (_, event) => (
      <div className="flex flex-col">
        <span>{DEVICE_EVENT_LABELS[event.kind]}</span>
        <span className="text-xs text-muted">{describeEventDevice(event.detail) || event.deviceId}</span>
      </div>
    ),
  },
  { title: 'By', key: 'actor', render: (_, event) => event.actorName ?? <span className="text-muted">—</span> },
  { title: 'Reason', key: 'reason', render: (_, event) => event.reason ?? <span className="text-muted">—</span> },
];

/** Every phone the driver has used and what happened to it, newest first. */
export function DeviceHistoryTable({ history, list }: { history: Page<DriverDeviceEventView>; list: ListControls }) {
  return (
    <section aria-label="Device history" className="flex flex-col gap-2">
      <h3 className="text-sm font-medium text-fg">Device history</h3>
      <Table
        rowKey="id"
        dataSource={history.items}
        columns={COLUMNS}
        scroll={{ x: 'max-content' }}
        {...list.tableProps<DriverDeviceEventView>(history.total)}
      />
    </section>
  );
}
